require('./cardShowAndHideSensitiveInformation.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

class CardShowAndHideSensitiveInformationNonExpired extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleNavigate = this.handleNavigate.bind(this);
    }

    handleNavigate(){
        const { history } = this.props;
        history.goBack();
    }

    render() {
        const {textBack, title, codeNumber, messageShortNonExpired, messageNonExpired, isPin} = this.props;
        let nonExpiredContent;
        if (isPin) {
            nonExpiredContent = (
                <OKMessage type="important">
                    {messageNonExpired}
                </OKMessage>
            );
        }
        return (
            <div className="code-confirmation-success__container">
                <div className="code-confirmation-success__title">
                    {title}
                </div>
                <div className="code-confirmation-success__code">
                    {codeNumber}
                </div>
                <div className="code-confirmation-success__label">
                    {messageShortNonExpired}
                </div>
                {nonExpiredContent}
                <div className="code-confirmation-success__footer">
                    <OKLink
                        modifier="emphasize"
                        onClick={this.handleNavigate}
                    >
                        {textBack}
                    </OKLink>
                </div>
            </div>
        );
    }
}

CardShowAndHideSensitiveInformationNonExpired.propTypes = {
    cardId: PropTypes.string.isRequired,
    codeNumber: PropTypes.string.isRequired,
    immCard: PropTypes.object,
    title: PropTypes.string,
    textBack: PropTypes.string,
    messageNonExpired: PropTypes.string,
    messageShortNonExpired: PropTypes.string,
    isPin: PropTypes.bool.isRequired,
    history: PropTypes.object
};

module.exports = withRouter(CardShowAndHideSensitiveInformationNonExpired);